'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dI$002dP$0024$0024anon$002477 from "./presto.types$-I-P$$anon$77.js";
var $p;
/** @constructor */
function $c_Lpresto_types$IP$() {
  this.c7k = null;
  this.c7l = false;
  this.c7i = null;
  this.c7j = false;
  this.c7g = null;
  this.c7h = false;
  this.c7m = null;
  this.c7n = false;
}
export { $c_Lpresto_types$IP$ as $c_Lpresto_types$IP$ };
$p = $c_Lpresto_types$IP$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$IP$;
/** @constructor */
function $h_Lpresto_types$IP$() {
}
export { $h_Lpresto_types$IP$ as $h_Lpresto_types$IP$ };
$h_Lpresto_types$IP$.prototype = $p;
$p.cId = (function() {
  if ((!this.c7l)) {
    this.c7k = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c7l = true;
  }
  return this.c7k;
});
$p.crB = (function() {
  if ((!this.c7j)) {
    this.c7i = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c7j = true;
  }
  return this.c7i;
});
$p.cHb = (function() {
  if ((!this.c7h)) {
    this.c7g = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c7h = true;
  }
  return this.c7g;
});
$p.cIw = (function() {
  if ((!this.c7n)) {
    this.c7m = new $j_presto$002etypes$0024$002dI$002dP$0024$0024anon$002477.$c_Lpresto_types$IP$$anon$77(this);
    this.c7n = true;
  }
  return this.c7m;
});
var $d_Lpresto_types$IP$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$IP$, "presto.types$IP$", ({
  a0R: 1,
  D: 1
}));
export { $d_Lpresto_types$IP$ as $d_Lpresto_types$IP$ };
var $n_Lpresto_types$IP$;
function $m_Lpresto_types$IP$() {
  if ((!$n_Lpresto_types$IP$)) {
    $n_Lpresto_types$IP$ = new $c_Lpresto_types$IP$();
  }
  return $n_Lpresto_types$IP$;
}
export { $m_Lpresto_types$IP$ as $m_Lpresto_types$IP$ };
//# sourceMappingURL=presto.types$-I-P$.js.map
